import APP_ROUTES from "./app-views/routes";
import AUTH_ROUTES from "./auth-views/routes";

const ROUTES = [...APP_ROUTES, ...AUTH_ROUTES];

export default ROUTES;
